<template>
  <div class="search-box-area">
    <button type="button" v-if="isBackBtn" class="button-area" @click.prevent="onClickBackButton">
      <span class="a11y-hidden">뒤로 가기</span>
      <BackButton/>
    </button>
    <div :class="searchInputClass">
      <input
        type="text" placeholder="제목, 장르, 배우로 찾아보세요" class="input-search"
        @focus.prevent="onFocusSearchInput($event)"
        @keypress.enter="enter"
        @blur.prevent="onBlurSearchInput"
        :value="searchKeyword"
        ref="searchKeyword"
        @input="searchKeyword = $event.target.value" @keyup="getRecommendation"
        maxlength="50"
      >
      <button type="button" v-if="isInputCancelButton" @click.prevent="clickCancelInput()" class="search-delete">입력 취소</button>
    </div>
    <button type="button" v-if="isFocusOn" @click.prevent="cancelBtnClick()" class="search-cancel">취소</button>
  </div>
</template>
<script>
import { removePrefixEmptyString } from '@/common/util/common'
import { camelCase, capitalize, debounce, get } from 'lodash'
import { SearchService } from '@/common/api/api.service'
import { mapMutations } from 'vuex'
import utils from '@/common/util/utils'
import { EventBus } from '@/components/eventbus/EventBus'
import BackButton from '@/assets/svg/common/ic_gnb_back_w.svg'
import {
  SEARCH_AUTO_COMPLETE_KEYWORD_LIST_INFO,
  SEARCH_KEYWORD_VIEW_MODE
} from '@/common/utils/eventbus.const'
import { getBandTypeInfoByCellType } from '@/common/image.util'
import { sendEventLogTextSearch } from '@/common/util/log.v2.send'

export default {
  name: 'SearchInput',
  components: {
    BackButton
  },
  props: {
    isNavTab: {
      type: Boolean
    }
  },
  data () {
    return {
      isFocusOn: false,
      isBackBtn: false,
      hasNavTab: get(this.$route, 'query.bt', 'y') !== 'n',
      searchType: 'keyword',
      searchKeyword: get(this.$route, 'query.searchWord', get(this.$route, 'query.keyword', '')),
      keywordList: [],
      prevKeywordList: [],
      thumbnailInfo: {},
      originHeight: 0,
      isKeywordResult: false
    }
  },
  computed: {
    isInputCancelButton () {
      return this.isFocusOn && removePrefixEmptyString(this.searchKeyword) !== ''
    },
    searchInputClass () {
      let defaultClass = 'search-box-input-area'
      if (this.isInputCancelButton) defaultClass += ' with-search-delete'
      return defaultClass
    }
  },
  methods: {
    ...mapMutations(['hideNavigationMenu', 'showNavigationMenu']),
    resetData () {
      this.searchKeyword = ''
      this.keywordList = []
    },
    onClickBackButton () {
      this.$router.back()
    },
    onFocusSearchInput () {
      if (this.searchKeyword === '' || this.searchKeyword.length === 0) {
        this.hideNavigationMenu()
      }
      this.isFocusOn = true
      this.$refs['searchKeyword'].focus()
    },
    onBlurSearchInput () {
      this.showNavigationMenu()
    },
    enter () {
      this.isKeywordResult = true
      this.keywordList = []
      this.isFocusOn = false
      this.$refs['searchKeyword'].blur()
      EventBus.$emit(SEARCH_KEYWORD_VIEW_MODE, { isKeywordResult: this.isEnter })
      this.searchKeyword = removePrefixEmptyString(this.searchKeyword)
      if (this.searchKeyword.length === 0) return
      if (!this.isBackBtn) this.showNavigationMenu()

      const landingURL = `/search?searchCategory=all&searchWord=${this.searchKeyword}`

      sendEventLogTextSearch({ keyword: this.searchKeyword, route: this.$route, landingUrl: landingURL })
      this.$router.push(landingURL)
    },
    getRecommendation: debounce(function (e) { this.setRecommendation(e) }, 400),
    setRecommendation (e) {
      if (e.keyCode === 13) return
      if (removePrefixEmptyString(this.searchKeyword) === '' || this.searchKeyword.length === 0) {
        this.resetData()
        this.onFocusSearchInput()
      } else {
        SearchService.getRecommendKeywordByUserInput({ keyword: removePrefixEmptyString(this.searchKeyword) }).then(({ data }) => {
          const cellType = capitalize(camelCase(get(data, 'cell_toplist.cell_type', '')))
          this.thumbnailInfo = getBandTypeInfoByCellType(cellType)
          if (this.isKeywordResult) {
            this.keywordList = []
            this.isKeywordResult = false
          } else {
            if (get(data, 'cell_toplist.celllist', []).length > 0) {
              this.keywordList = get(data, 'cell_toplist.celllist', [])
              this.prevKeywordList = this.keywordList
            } else {
              if (this.keywordList.length !== 0) this.keywordList = this.prevKeywordList
            }
          }
        })
      }
    },
    clickCancelInput () {
      this.searchKeyword = ''
      this.keywordList = []
      this.$nextTick(() => {
        this.$refs['searchKeyword'].focus()
      })
    },
    cancelBtnClick () {
      if (get(this.$route, 'query.searchWord', '') !== '') {
        this.$router.push('/search')
      } else {
        this.searchKeyword = ''
        this.keywordList = []
      }
    },
    resizeView () {
      if (this.originHeight === window.innerHeight) {
        this.showNavigationMenu()
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.resizeView)
  },
  created () {
    this.originHeight = window.innerHeight
    if (get(this.$route, 'query.keyword', '') !== '') {
      this.$router.push('/search?category=all&searchWord=' + removePrefixEmptyString(get(this.$route, 'query.keyword', '')))
    }
    if (!this.hasNavTab) {
      this.isBackBtn = true
      this.hideNavigationMenu()
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeView)
  },
  watch: {
    $route (newRoute) {
      this.searchKeyword = get(newRoute, 'query.searchWord', '')
    },
    searchKeyword () {
      if (this.searchKeyword.length === 50) {
        utils.alert('최대 50자까지 입력 가능합니다. 글자수를 확인해주세요.')
      }
    },
    keywordList () {
      EventBus.$emit(SEARCH_AUTO_COMPLETE_KEYWORD_LIST_INFO, {
        keywordList: this.keywordList,
        thumbnailInfo: this.thumbnailInfo
      })
    }
  }
}
</script>
<style lang="css" src="@/assets/new-css/search.css"></style>
